import createElement from '../utils/create-element';
import messages from '../messages/common';

/**
 * @typedef {Modal} Modal
 */
class Modal {
    /** @type {string} */
    idName = 'commonModal';

    /** @type {HTMLDivElement} */
    activeModal;

    /** @type {null|string} */
    content;

    /** @type {string} */
    size;

    /**
     * @param {?string} content
     * @param {?string} size
     */
    constructor({content = '', size = ''}) {
        this.selectors = {
            wrap: 'data-modal-wrap-content',
            overlay: 'reveal-overlay',
        };
        this.size = size ? `${size} ` : '';
        this.content = content;
        this.messages = messages();
        this.render();
    }

    /**
     * @param {{content: ?string, [size: ?string]}} data
     * @return {Modal}
     */
    static run(data) {
        return new Modal(data);
    }

    /** @return {void} */
    render() {
        const wrap = document.getElementById(this.idName);

        if (wrap) {
            wrap.closest('.reveal-overlay').remove();
        }

        this.activeModal = createElement(
            `<div class="${this.size}reveal modal" id="${this.idName}" data-reveal data-reset-on-close="true">
                <div ${this.selectors.wrap}>
                    ${this.content}
                </div>
                <button class="close-button" data-close aria-label="Закрыть окно" type="button">
                    <svg class="icon-close-modal" aria-hidden="true">
                        <use xlink:href="dist/images/sprites.svg#close-modal"></use>
                    </svg>
                </button>
            </div>`,
        );

        document.body.append(this.activeModal);
        $(document).foundation();
        const GeneralModal = $(`#${this.idName}`);

        GeneralModal.foundation('open');
        GeneralModal.on('closed.zf.reveal', (e) => {
            e.currentTarget.closest('.reveal-overlay').remove();
        });
    }

    /**
     * @param {string} content
     * @return {Promise<void>}
     */
    async insertHtml(content) {
        /** @type {HTMLDivElement} */
        const wrap = this.activeModal.querySelector(`[${this.selectors.wrap}]`);

        if (wrap) {
            wrap.innerHTML = content;
        }
    }

    /** @return {void} */
    showError() {
        this.insertHtml(
            `<div class="modal__title modal__title--center">${this.messages.textError}</div>
            <div class="modal__descriptions">${this.messages.textLoadError}</div>`,
        );
    }

    /** @return {void} */
    destroy() {
        const parent = this.activeModal.parentNode;

        if (parent && parent.classList.contains(this.selectors.overlay)) {
            parent.remove();
        } else {
            this.activeModal.remove();
        }

        this.elem = null;
        this.content = null;
    }
}

export default Modal;
